import React from 'react'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs'
import { Section } from '@shared/components/section'

import { Tab2012 } from './tabs/2012'
import { Tab2017 } from './tabs/2017'
import { Tab2018 } from './tabs/2018'
import { Tab2019 } from './tabs/2019'
import { Tab2020 } from './tabs/2020'
import { Tab2021 } from './tabs/2021'
import { Tab2022 } from './tabs/2022'
import { Tab2023 } from './tabs/2023'
import { Tab2024 } from './tabs/2024'
import { data } from './data'

import styles from './styles.module.scss'

const YEARS = ['2012', '2017', '2018', '2019', '2020', '2021', '2022', '2023', '2024']

const TabsContent = [
	Tab2012,
	Tab2017,
	Tab2018,
	Tab2019,
	Tab2020,
	Tab2021,
	Tab2022,
	Tab2023,
	Tab2024,
]

export const View = () => {
	return (
		<Section className={styles.longHistory}>
			<h2 className={styles.heading}>{data.heading}</h2>
			<Tabs selectedTabClassName={styles.activeTab}>
				<TabList className={styles.tabsList}>
					{YEARS.map((year) => (
						<Tab key={year} className={styles.tab}>
							{year}
						</Tab>
					))}
				</TabList>

				{TabsContent.map((TabComponent, index) => (
					<TabPanel key={YEARS[index]}>
						<TabComponent />
					</TabPanel>
				))}
			</Tabs>
		</Section>
	)
}
